import React from 'react'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import { MotionCard, MotionIcon, MotionSection } from '../motion/Motion'

export default function ContactBenefitsSection() {
  return (
    <MotionSection className="w-full py-12 lg:py-16">
      <div className="w-[96%] sm:w-[92%] md:w-[90%] lg:w-[90%] mx-auto">
        <div className="grid gap-5 sm:grid-cols-3 sm:gap-6 text-center">
          <MotionCard className="flex flex-col items-center" delay={0.02}>
            <div className="h-16 w-16 rounded-full bg-gray-300 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-pink-500 flex items-center justify-center">
                <MotionIcon>
                  <LocalShippingIcon fontSize="small" className="text-white" />
                </MotionIcon>
              </div>
            </div>
            <h3 className="mt-4 text-sm font-bold tracking-wide text-gray-900">FREE AND FAST DELIVERY</h3>
            <p className="mt-2 text-xs text-gray-600">Fast door-to-door delivery across Gauteng</p>
          </MotionCard>

          <MotionCard className="flex flex-col items-center" delay={0.07}>
            <div className="h-16 w-16 rounded-full bg-gray-300 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-pink-500 flex items-center justify-center">
                <MotionIcon>
                  <HeadsetMicIcon fontSize="small" className="text-white" />
                </MotionIcon>
              </div>
            </div>
            <h3 className="mt-4 text-sm font-bold tracking-wide text-gray-900">24/7 CUSTOMER SERVICE</h3>
            <p className="mt-2 text-xs text-gray-600">Friendly 24/7 customer support</p>
          </MotionCard>

          <MotionCard className="flex flex-col items-center" delay={0.12}>
            <div className="h-16 w-16 rounded-full bg-gray-300 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-pink-500 flex items-center justify-center">
                <MotionIcon>
                  <VerifiedUserIcon fontSize="small" className="text-white" />
                </MotionIcon>
              </div>
            </div>
            <h3 className="mt-4 text-sm font-bold tracking-wide text-gray-900">MONEY BACK GUARANTEE</h3>
            <p className="mt-2 text-xs text-gray-600">We return money within 30 days</p>
          </MotionCard>
        </div>
      </div>
    </MotionSection>
  )
}
